<app-main-resource-catalog [scope]="AppScope.TEST"></app-main-resource-catalog>
